/* ════════════════════════════════════════════════════════════
   smooth-scroll.js
   Intercepts clicks on any <a href="#..."> link and smoothly
   scrolls to the matching element WITHOUT updating the URL.

   How it works:
   - Listens at document level for clicks on anchor tags
   - If href starts with '#' and matches a real element on the
     page, prevents default browser behavior and uses
     scrollIntoView({behavior: 'smooth'}) instead
   - Respects sticky headers via an optional scroll offset
   - Falls back gracefully if the target ID doesn't exist
   ════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  // Pixel offset from the top — accounts for sticky header.
  // Read from a CSS variable on <html> if set, else fall back to 80.
  function getScrollOffset() {
    var rootStyle = getComputedStyle(document.documentElement);
    var val = parseInt(rootStyle.getPropertyValue('--smooth-scroll-offset'), 10);
    return isNaN(val) ? 80 : val;
  }

  function smoothScrollTo(element) {
    var offset = getScrollOffset();
    var rect = element.getBoundingClientRect();
    var targetY = window.pageYOffset + rect.top - offset;

    // Respect reduced-motion preference
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: targetY,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  }

  function handleClick(e) {
    // Walk up the DOM in case the click hit a child of the <a>
    var anchor = e.target.closest('a[href]');
    if (!anchor) return;

    var href = anchor.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;

    // Ignore bare '#' and '#!' (no real target)
    if (href === '#' || href === '#!') return;

    // Modifier keys / non-primary clicks → let the browser handle
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    // Find the target
    var targetId = href.slice(1);
    var target;
    try {
      target = document.getElementById(targetId);
    } catch (err) {
      target = null;
    }

    if (!target) return;

    // We have a valid match — prevent default and scroll smoothly
    e.preventDefault();
    smoothScrollTo(target);

    // Move keyboard focus to the target for accessibility,
    // without scrolling (preventScroll: true).
    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }
    target.focus({ preventScroll: true });
  }

  // Use capture phase to intercept before other handlers
  document.addEventListener('click', handleClick);

  // On initial page load, if URL has a hash, scroll smoothly to it
  // after a brief delay (lets fonts/images settle).
  window.addEventListener('load', function () {
    if (window.location.hash && window.location.hash.length > 1) {
      var hashTarget = document.getElementById(window.location.hash.slice(1));
      if (hashTarget) {
        // Cancel browser's instant jump
        window.scrollTo(0, 0);
        setTimeout(function () {
          smoothScrollTo(hashTarget);
        }, 50);
      }
    }
  });
})();